import React, { useState, useEffect } from "react";
import {
  Container,
  Table,
  Form,
  Row,
  Col,
  Modal,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Barcode from "react-barcode";
import Header from "../component/Header";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";
import { useDispatch, useSelector } from "react-redux";
import Paginationcomponent from "../component/pagination";
import { useNavigate } from "react-router-dom";
import {
  getMypatient,
  getAllMyPatientPage,
  toggleArchivePatient,
  updatePatientEmail,
  deleteMyPatient,
} from "./../Redux/actions/Patientaction";
import notify from "../Hook/useNotification";
import { useTranslation } from "react-i18next";

const FILTERS_WITH_DATE_RANGE = ["newPatients", "reportCustomRange"];

const PatientTableUI = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [keyword, setKeyword] = useState("");
  const [archiveLoading, setArchiveLoading] = useState({});
  const [refreshData, setRefreshData] = useState(false);
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [, setDeleteLoading] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editPatient, setEditPatient] = useState(null);
  const [editEmail, setEditEmail] = useState("");
  const [editConsent, setEditConsent] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const userFromStorage = JSON.parse(localStorage.getItem("user"));
  const doctorId = userFromStorage?._id;

  const handleShowEdit = (patient) => {
    setEditPatient(patient);
    setEditEmail(patient.email || "");
    setEditConsent(
      patient.doctors?.some((o) => o.doctorConsent?.consentToReports) || false,
    );
    setShowEdit(true);
  };

  const handleCloseEdit = () => {
    setShowEdit(false);
    setEditPatient(null);
  };

  const handleClose = () => {
    setShow(false);
    setDeleteId(null);
  };

  const handleShow = (id) => {
    setDeleteId(id);
    setShow(true);
  };

  const handleEditConfirmed = async () => {
    const data = {};
    if (editEmail && editEmail !== editPatient?.email) data.email = editEmail;
    data.consentFlag = editConsent;

    if (!Object.keys(data).length) return handleCloseEdit();

    setEditLoading(true);
    await dispatch(updatePatientEmail(editPatient._id, data));

    setEditLoading(false);
    handleCloseEdit();
    dispatch(getMypatient(10, keyword));
    notify(t("patienttableui.notifications.updateSuccess"), "success");
  };
  useEffect(() => {
    dispatch(getMypatient(10, keyword));
  }, [keyword, dispatch]);

  const handleDeleteConfirmed = async () => {
    setDeleteLoading(true);
    await dispatch(deleteMyPatient(deleteId));
    setDeleteLoading(false);
    handleClose();
    dispatch(getMypatient(10, keyword));
    notify(t("patienttableui.notifications.deleteSuccess"), "success");
  };

  const handleFilterTypeChange = (e) => {
    const value = e.target.value;
    setFilterType(value);
    // مسح التواريخ القديمة لو خرجنا من فلتر بيستخدم تواريخ
    if (!FILTERS_WITH_DATE_RANGE.includes(value)) {
      setDateFrom("");
      setDateTo("");
    }
  };

  // تطبيق فترة مخصصة (للفلتر اللي محتاج dateFrom/dateTo إجباري)
  const handleApplyCustomRange = () => {
    if (filterType === "reportCustomRange" && (!dateFrom || !dateTo)) {
      notify(t("patientTable.notifications.dateRangeRequired"), "error");
      return;
    }
    dispatch(getMypatient(10, keyword, { filterType, dateFrom, dateTo }));
  };

  // مسح الفلتر والرجوع لعرض كل المرضى
  const handleClearFilter = () => {
    setFilterType("");
    setDateFrom("");
    setDateTo("");
    dispatch(getMypatient(10, keyword, {}));
  };
  useEffect(() => {
    if (filterType === "reportCustomRange") return; // ينتظر زرار التطبيق بتاع الفترة المخصصة
    dispatch(getMypatient(10, keyword, { filterType, dateFrom, dateTo }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword, filterType, dispatch]);

  const MypatinetData = useSelector((state) => state.allpatient.mypatient);
  const Loading = useSelector((state) => state.allpatient.loading);

  let pagecount = 0;
  if (MypatinetData?.paginationresults?.numberOfPages) {
    pagecount = MypatinetData?.paginationresults?.numberOfPages;
  }

  const getpage = (page) => {
    dispatch(getAllMyPatientPage(page));
  };

  const AllPatient = MypatinetData?.data?.patients || [];
  console.log("AllPatient", AllPatient);


  const handleView = (id) => {
    setTimeout(() => {
      navigate(`/ReportsList/${id}`);
    }, 1000);
  };


  const handleToggleArchive = async (patientId) => {
    try {
      setArchiveLoading((prev) => ({ ...prev, [patientId]: true }));
      await dispatch(toggleArchivePatient(patientId));
      setRefreshData((prev) => !prev);
      notify(t("patienttableui.success_archive_message"), "success");
    } catch (error) {
      notify(t("patienttableui.error_archive_message"), "error");
    } finally {
      setArchiveLoading((prev) => ({ ...prev, [patientId]: false }));
    }
  };

  // useEffect لإعادة تحميل البيانات عند تغيير refreshData
  useEffect(() => {
    if (refreshData !== false) {
      // استدعاء دالة جلب البيانات مرة أخرى
      // مثال: dispatch(getAllPatients());
      dispatch(getMypatient(10, keyword));
    }
  }, [refreshData, keyword, dispatch]);

  const showDateRange =
    filterType === "newPatients" || filterType === "reportCustomRange";

  return (
    <>
      <Header />
      <NavBar />
      <Container className="mt-5">
        <h2 className="text-center mb-4 fw-bold button-color">
          {t("patienttableui.title")}
        </h2>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Control
              placeholder={t("patienttableui.search_placeholder")}
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </Col>
        </Row>
        <Row className="mb-3 align-items-end g-2">
          <Col md={3}>
            <Form.Label className="small text-muted mb-1">
              {t("patienttableui.filters.label")}
            </Form.Label>
            <Form.Select value={filterType} onChange={handleFilterTypeChange}>
              <option value="">{t("patienttableui.filters.all")}</option>
              <option value="newPatients">
                {t("patienttableui.filters.newPatients")}
              </option>
              <option value="reportToday">
                {t("patienttableui.filters.reportToday")}
              </option>
              <option value="reportThisMonth">
                {t("patienttableui.filters.reportThisMonth")}
              </option>
              <option value="reportCustomRange">
                {t("patienttableui.filters.reportCustomRange")}
              </option>
              <option value="pendingReport">
                {t("patienttableui.filters.pendingReport")}
              </option>
              <option value="reportFailed">
                {t("patienttableui.filters.reportFailed")}
              </option>
              <option value="noReport">
                {t("patienttableui.filters.noReport")}
              </option>
              <option value="aiJustCompleted">
                {t("patienttableui.filters.aiJustCompleted")}
              </option>
            </Form.Select>
          </Col>

          {showDateRange && (
            <>
              <Col md={2}>
                <Form.Label className="small text-muted mb-1">
                  {t("patienttableui.filters.dateFrom")}
                </Form.Label>
                <Form.Control
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <Form.Label className="small text-muted mb-1">
                  {t("patienttableui.filters.dateTo")}
                </Form.Label>
                <Form.Control
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <Button
                  variant="primary"
                  className="w-100"
                  onClick={handleApplyCustomRange}
                >
                  {t("patienttableui.filters.apply")}
                </Button>
              </Col>
            </>
          )}

          {filterType && (
            <Col md={2}>
              <Button
                variant="outline-secondary"
                className="w-100"
                onClick={handleClearFilter}
              >
                {t("patienttableui.filters.clear")}
              </Button>
            </Col>
          )}
        </Row>

        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>{t("patienttableui.table_headers.index")}</th>
              <th>{t("patienttableui.table_headers.name")}</th>
              <th>{t("patienttableui.table_headers.date_of_birth")}</th>
              <th>{t("patienttableui.table_headers.ai_report_count")}</th>
              <th>{t("patienttableui.table_headers.tools")}</th>
            </tr>
          </thead>
          <tbody>
            {Loading ? (
              <tr>
                <td colSpan="7" className="text-center">
                  {t("patienttableui.loading_text")}
                </td>
              </tr>
            ) : AllPatient.length > 0 ? (
              AllPatient.map((patient, index) => (
                <tr key={index}>
                  <td>
                    {(() => {
                      const lastReport =
                        patient.report?.[patient.report.length - 1];
                      const modelResults = lastReport?.modelResults;
                      let riskColor = "";

                      if (modelResults?.leftEye || modelResults?.rightEye) {
                        const left = modelResults.leftEye
                          ? JSON.parse(modelResults.leftEye)
                          : null;
                        const right = modelResults.rightEye
                          ? JSON.parse(modelResults.rightEye)
                          : null;

                        const confidences = [];

                        const extractConfidences = (eyeData) => {
                          if (!eyeData) return;
                          for (const key in eyeData) {
                            const conf = eyeData[key]?.confidence;
                            if (conf !== null && typeof conf === "number") {
                              confidences.push(conf);
                            }
                          }
                        };

                        extractConfidences(left);
                        extractConfidences(right);

                        const maxConfidence = Math.max(...confidences, 0);

                        if (maxConfidence > 80) {
                          riskColor = "bg-danger text-white";
                        } else if (maxConfidence >= 60) {
                          riskColor = "bg-warning text-dark";
                        } else {
                          riskColor = "bg-success text-white";
                        }
                      }

                      return (
                        <span className={`px-2 py-1 rounded ${riskColor}`}>
                          {index + 1}
                        </span>
                      );
                    })()}
                  </td>
                  <td>
                    {patient.salutation ||
                    patient.firstName ||
                    patient.lastName ? (
                      <>
                        {patient.salutation ? (
                          patient.salutation
                        ) : (
                          <span style={{ color: "red" }}>---</span>
                        )}
                        .
                        {patient.firstName ? (
                          patient.firstName
                        ) : (
                          <span style={{ color: "red" }}>---</span>
                        )}{" "}
                        {patient.lastName ? (
                          patient.lastName
                        ) : (
                          <span style={{ color: "red" }}>---</span>
                        )}
                      </>
                    ) : (
                      <span style={{ color: "red" }}>---</span>
                    )}
                  </td>
                  <td>
                    {patient.dateOfBirth ? (
                      new Date(patient.dateOfBirth).toLocaleDateString("de-DE")
                    ) : (
                      <span style={{ color: "red" }}>---</span>
                    )}
                  </td>
                  <td>{patient?.reportsCount || 0}</td>
                  <td>
                    {patient?.createdBy === doctorId && (
                      <button
                        className="btn btn-sm btn-outline-danger me-2"
                        onClick={() => handleShow(patient._id)}
                      >
                        <i className="bi bi-trash"></i>
                      </button>
                    )}
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => handleView(patient._id)}
                    >
                      <i className="bi bi-eye"></i>
                    </button>
                    <button
                      className="btn btn-sm btn-outline-secondary me-2"
                      onClick={(e) => handleToggleArchive(patient._id, e)}
                      disabled={archiveLoading[patient._id]}
                    >
                      <i className="bi bi-archive"></i>
                    </button>
                    {patient?.doctors?.some(
                      (d) =>
                        d.doctorConsent?.consentToReports &&
                        d.doctor?._id === doctorId,
                    ) && (
                      <button
                        className="btn btn-sm btn-outline-success me-2"
                        onClick={() => navigate(`/Examination/${patient._id}`)}
                      >
                        <i className="bi bi-journal-plus"></i>
                      </button>
                    )}
                    <button
                      className="btn btn-sm btn-outline-warning me-2"
                      onClick={() => handleShowEdit(patient)}
                    >
                      <i className="bi bi-pencil"></i>
                    </button>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-barcode-${patient._id}`}>
                          <Barcode
                            value={patient.patientId?.toString() || "---"}
                            height={40}
                            width={2}
                            fontSize={12}
                          />
                        </Tooltip>
                      }
                    >
                      <button className="btn btn-sm btn-outline-dark">
                        <i className="bi bi-upc"></i>
                      </button>
                    </OverlayTrigger>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  {t("patienttableui.no_patients_text")}
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {pagecount > 1 && (
          <Paginationcomponent pagecount={pagecount} onpress={getpage} />
        )}
      </Container>
      <Modal show={showEdit} onHide={handleCloseEdit}>
        <Modal.Header closeButton>
          <Modal.Title>Edit patient</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={editEmail}
              onChange={(e) => setEditEmail(e.target.value)}
              placeholder="patient@email.com"
            />
            <Form.Text className="text-muted">
              Credentials will be sent to this email once updated.
            </Form.Text>
          </Form.Group>
          <Form.Group>
            <Form.Check
              type="checkbox"
              id="editConsent"
              checked={editConsent}
              onChange={(e) => setEditConsent(e.target.checked)}
              label="Allow optician to create reports"
            />
            <Form.Text className="text-muted ms-4">
              {editConsent ? "✅ Consent recorded." : "⏳ Consent not granted."}
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEdit}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleEditConfirmed}
            disabled={editLoading}
          >
            {editLoading ? "Saving..." : "Save changes"}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>{t("patienttableui.modal.title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("patienttableui.modal.body")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("patienttableui.modal.cancel")}
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirmed}>
            {t("patienttableui.modal.delete")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </>
  );
};

export default PatientTableUI;
